/**
 * Trasforma il markdown di Aida in **frasi parlabili** per il TTS:
 * - rimuove i simboli markdown (grassetto/corsivo/codice/link/heading/bullet);
 * - sostituisce le tabelle con un annuncio ("Ho preparato una tabella con N voci…");
 * - segmenta in frasi (per la lettura "a frase", lag ~1 frase).
 *
 * `completo=false` durante lo streaming scarta l'ultima frase se non è ancora
 * terminata (evita di leggere mezza parola); a fine risposta passare `true`.
 */

function isPipeRow(line: string): boolean {
  return line.trim().length > 0 && line.includes("|");
}

function celle(line: string): string[] {
  return line
    .trim()
    .replace(/^\|/, "")
    .replace(/\|$/, "")
    .split("|")
    .map((c) => c.trim());
}

function isSeparatorRow(line: string): boolean {
  return celle(line).every((c) => /^:?-{1,}:?$/.test(c.trim()));
}

function stripInline(s: string): string {
  return s
    .replace(/^#{1,6}\s+/, "") // heading
    .replace(/^\s*[-*]\s+/, "") // bullet
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1") // link → testo
    .replace(/\*\*([^*]+)\*\*/g, "$1") // grassetto
    .replace(/\*([^*\n]+)\*/g, "$1") // corsivo
    .replace(/`([^`]+)`/g, "$1"); // codice
}

export function segmentiParlabili(testo: string, completo: boolean): string[] {
  const lines = testo.split("\n");
  const blocchi: string[] = [];

  let i = 0;
  while (i < lines.length) {
    const line = lines[i];

    if (isPipeRow(line)) {
      const gruppo: string[] = [];
      let j = i;
      while (j < lines.length) {
        if (isPipeRow(lines[j])) {
          gruppo.push(lines[j]);
          j++;
        } else if (lines[j].trim() === "" && j + 1 < lines.length && isPipeRow(lines[j + 1])) {
          j++;
        } else {
          break;
        }
      }
      if (gruppo.length >= 2 && isSeparatorRow(gruppo[1])) {
        const n = Math.max(0, gruppo.length - 2);
        blocchi.push(
          `Ho preparato una tabella con ${n} ${n === 1 ? "voce" : "voci"}, la trovi qui sotto.`,
        );
        i = j;
        continue;
      }
    }

    const pulita = stripInline(line).trim();
    if (pulita) blocchi.push(pulita);
    i++;
  }

  let segmenti: string[] = [];
  for (const b of blocchi) {
    const frasi = b
      .split(/(?<=[.!?])\s+/)
      .map((s) => s.trim())
      .filter(Boolean);
    segmenti.push(...(frasi.length ? frasi : [b]));
  }

  if (!completo && segmenti.length) {
    const ultima = segmenti[segmenti.length - 1];
    if (!/[.!?:]$/.test(ultima)) segmenti = segmenti.slice(0, -1);
  }
  return segmenti;
}
